import { ApOverviewResponse, JobOverviewResponse, TagOverviewResponse } from '@/types/pages/dashboard';
import { APIResponse } from '../types';
import httpService from './httpService';

export const fetchApOverview = (cid: number): APIResponse<ApOverviewResponse> => {
    return httpService.get(`/store/dashboard/${cid}/ap_overview`);
};

export const fetchJobOverview = (cid: number): APIResponse<JobOverviewResponse> => {
    return httpService.get(`/store/dashboard/${cid}/job_overview`);
};

export const fetchTagOverview = (cid: number): APIResponse<TagOverviewResponse> => {
    return httpService.get(`/store/dashboard/${cid}/tag_overview`);
};
